var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"ds-modal-header-title"},[_vm._t("title",function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]})],2),(_vm.subtitle || _vm.$slots.subtitle)?_c('p',{staticClass:"ds-modal-header-subtitle"},[_vm._t("subtitle",function(){return [_vm._v(" "+_vm._s(_vm.subtitle)+" ")]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }